import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { api } from "../../redux/apis/api";
import { FormDateField } from "../../components/form/date";
import { FormDropDown } from "../../components/form/dropdown";
import { useEffect, useState } from "react";
import deleteIcon from "../../assets/icons/red-bin.svg";
import CustomerCreateModal from "../../components/modal/customer-create-modal";
import CustomerDeliveryAddressCreateModal from "../../components/customer-components/customer-delivery-address/customer-delivery-address-create-modal";
import OrderProductItem from "./order-product-item";
const EditOrders = () => {
  const params = useParams();

  const naviagte = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const customer_id = queryParamsData.get("customer_id") ?? "";
  const [customerlist, setcustomerlist] = useState([]);
  const [customerDatalist, setcustomerDatalist] = useState([]);
  const [addresslist, setAddresslist] = useState([]);
  const [addressDatalist, setAddressDatalist] = useState([]);
  const [customerCreateShow, setcustomerCreateShow] = useState(false);
  const [customerDeliveryCreateShow, setcustomerDeliveryCreateShow] =
    useState(false);
  const [companyList, setcompanyList] = useState([]);
  const [productList, setproductList] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [deliveryAddress, setDeliveryAddress] = useState({});

  const [orderProducts, setOrderProducts] = useState([]);

  const [initialValues, setInitialValues] = useState({
    ffadmin_id: "",
    customer_id: customer_id ?? "",
    customer_delivery_address: "",
    company_id: "",
    invoice_number: "",
    order_date: "",
    status: "draft",
    billing_type: "full",
    payment_mode: "",
    is_credit: false,
    payment_duration: 0,
    transport_vehical_number: "",
    cancelled_returned_reason: "",
  });

  const [orderValues, setOrderValues] = useState({
    total_before_tax: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    total_after_tax: 0,
    total_cash_amount: 0,
    total_invoice_value: 0,
  });

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = () => {
    setLoading(true);
    api
      .post(`/order/read`, {
        id: params?.id,
      })
      .then((res) => {
        console.log("res", res);

        setData(res.data.data);

        var order = res?.data?.data?.order;
        if (order) {
          setInitialValues({
            customer_id: order.customer_id,
            customer_delivery_address: order.customer_delivery_address,
            invoice_number: order.invoice_number,
            order_date: order.order_date,
            status: order.status,
            billing_type: order.billing_type,
            payment_mode: order.payment_mode,
            is_credit: order.is_credit,
            payment_duration: order.payment_duration,
            transport_vehical_number: order.transport_vehical_number,
            cancelled_returned_reason: order.cancelled_returned_reason,
            company_id: order.company_id,
          });

          setOrderValues({
            total_before_tax: order.total_before_tax,
            cgst: order.cgst,
            sgst: order.sgst,
            igst: order.igst,
            total_after_tax: order.total_after_tax,
            total_cash_amount: order.total_cash_amount,
            total_invoice_value: order.total_invoice_value,
          });
          setOrderProducts([...res?.data?.data?.products]);

          if (order.customer_delivery_address) {
            setDeliveryAddress({
              ...order.customer_obj.customer_delivery_addresses,
            });

            fetchaddressDropDownData(order.customer_id);
          }
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");

    var params = {
      id: data.order.id,
      ...values,
      ...orderValues,
      products: [...orderProducts],
    };

    console.log("params", params);

    api
      .post(`/order/edit`, JSON.stringify(params))
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        if (customer_id) {
          naviagte(`/customer/view/${customer_id}`);
        } else {
          naviagte(`/orders/list`);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const statusOptions = [
    {
      label: "Draft",
      value: "draft",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    },
    {
      label: "Submitted",
      value: "submitted",
    },
    {
      label: "Refunded",
      value: "refunded",
    },
  ];

  const billingTypeOptions = [
    {
      label: "Half",
      value: "half",
    },
    {
      label: "Full",
      value: "full",
    },
    {
      label: "None",
      value: "none",
    },
  ];

  const paymentOptions = [
    {
      label: "Online",
      value: "online",
    },
    {
      label: "Cash",
      value: "cash",
    },
    {
      label: "Cheque",
      value: "cheque",
    },
  ];

  const creditOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  useEffect(() => {
    fetchCustomerDropDownData();
    fetchProductDropDownData();
    fetchCompanyDropDownData();
  }, []);

  const fetchCompanyDropDownData = () => {
    api
      .post(`/company/list`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcompanyList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    if (customer_id) {
      fetchaddressDropDownData(customer_id);
    }
  }, [customer_id]);

  const fetchCustomerDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcustomerlist(newArr);
        setcustomerDatalist(res?.data?.data?.customers);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchaddressDropDownData = (customer_id) => {
    api
      .post(`/employee-request/customer-address-dropdown`, { customer_id })
      .then((res) => {
        let newArr = res?.data?.data?.addresses?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setAddresslist(newArr);
        setAddressDatalist(res?.data?.data?.addresses);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchProductDropDownData = () => {
    api
      .post(`/product/product-dropdown-list`)
      .then((res) => {
        let newArr = res?.data?.data?.products?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        var arr = res?.data?.data?.products;

        setProducts([...arr]);

        setproductList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  if (loading) {
    return (
      <MainLayout>
        <section className="h-full overflow-auto px-3">
          <h2 className="text-xl font-semibold capitalize">Loading</h2>
        </section>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <CustomerCreateModal
        isOpen={customerCreateShow}
        onClose={() => setcustomerCreateShow(false)}
      />
      <CustomerDeliveryAddressCreateModal
        isOpen={customerDeliveryCreateShow}
        onClose={() => {
          setcustomerDeliveryCreateShow(false);
        }}
        listFnc={fetchCustomerDropDownData}
      />
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => {
            var selctedCustomerData = {};
            var selctedCustomerDeliveryData = {};
            if (values?.customer_id) {
              selctedCustomerData = customerDatalist?.find(
                (item) => item?.id === values?.customer_id
              );
            }
            // if (values?.customer_delivery_address) {
            //     selctedCustomerDeliveryData = addressDatalist?.find(
            //         (item) =>
            //             item?.id ===
            //             values?.customer_delivery_address
            //     );
            // }
            return (
              <Form>
                <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                  <h2 className="text-xl font-semibold capitalize">
                    Order - Edit : id : {data.order.id}
                  </h2>
                  <div className="flex gap-3 items-center">
                    <button
                      onClick={() => naviagte("/orders/list")}
                      type="button"
                      className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <section>
                  <section>
                    <section className="w-full max-w-[60rem] flex gap-5">
                      <div className="my-4 w-full">
                        <FormTextField
                          name={"invoice_number"}
                          label={"Invoice No"}
                          placeholder={`Enter invoice number`}
                        />
                      </div>
                      <div className="my-4 w-full">
                        <FormDateField
                          name={"order_date"}
                          label={"order date"}
                        />
                      </div>

                      <div className="my-4 w-full">
                        <FormDropDown
                          name="status"
                          label="status"
                          options={statusOptions}
                        />
                      </div>
                      <div className="my-4 w-full">
                        <FormDropDown
                          name="company_id"
                          label="Company"
                          options={companyList}
                        />
                      </div>
                      {values.status == "cancelled" ||
                      values.status == "refunded" ? (
                        <div className="my-4 w-full">
                          <FormTextField
                            name={"cancelled_returned_reason"}
                            label={"Cancelled Returned reason"}
                            placeholder={`Enter Cancelled Returned reason`}
                          />
                        </div>
                      ) : null}
                    </section>
                    <section className="w-full max-w-[70rem] flex gap-5">
                      <div className="my-4 w-full">
                        <FormDropDown
                          name="customer_id"
                          label="Customer"
                          options={customerlist}
                          onChangeExtra={(customerId) => {
                            if (customerId) {
                              fetchaddressDropDownData(customerId);
                            }
                          }}
                        />
                      </div>

                      <div className="my-4 pt-7 w-full">
                        <div className="border-[1px] border-[#D9D9D9] rounded-md bg-white p-3 text-[#4B4B4B] text-fs_14">
                          <h1>Customer Details</h1>
                          <div className="flex items-center">
                            <h1>Name:</h1>
                            <p className="px-1">{selctedCustomerData?.name}</p>
                          </div>
                          <div className="flex items-center">
                            <h1>GST:</h1>
                            <p className="px-1">
                              {selctedCustomerData?.gst_number}
                            </p>
                          </div>
                          <div className="flex flex-col items-start">
                            <h1 className="text-nowrap text-[#4B4B4B]">
                              Billing Address:
                            </h1>
                            <p className="px-1">
                              {selctedCustomerData?.address}
                              {selctedCustomerData?.city?.name
                                ? " ," + selctedCustomerData?.city?.name
                                : ""}
                              {selctedCustomerData?.state?.name
                                ? " ," + selctedCustomerData?.state?.name
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="my-4 w-full">
                        <FormDropDown
                          name="customer_delivery_address"
                          label="Delivery Address"
                          options={addresslist}
                          onChangeExtra={(addressId) => {
                            if (addressId) {
                              var foundItem = addressDatalist?.find(
                                (item) => item?.id === addressId
                              );
                              setDeliveryAddress(foundItem);
                            }
                          }}
                        />
                      </div>
                      <div className="my-4 pt-7 w-full">
                        <div className="border-[1px] border-[#D9D9D9] rounded-md bg-white p-3 text-[#4B4B4B] text-fs_14">
                          <div className="flex flex-col items-start">
                            <h1 className="text-nowrap text-[#4B4B4B]">
                              Delivery Address
                            </h1>
                            <p className="px-1">
                              {deliveryAddress?.address}
                              {deliveryAddress?.city?.name
                                ? " ," + deliveryAddress?.city?.name
                                : ""}
                              {deliveryAddress?.state?.name
                                ? " ," + deliveryAddress?.state?.name
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section className="w-full max-w-[80rem] flex gap-5">
                      <div className="my-4 w-full">
                        <FormDropDown
                          name="billing_type"
                          label="Billing Type"
                          options={billingTypeOptions}
                        />
                      </div>

                      <div className="my-4 w-full">
                        <FormDropDown
                          name="payment_mode"
                          label="Payment Mode"
                          options={paymentOptions}
                        />
                      </div>

                      <div className="my-4 w-full">
                        <FormDropDown
                          name="is_credit"
                          label="Is Credit"
                          options={creditOptions}
                        />
                      </div>

                      <div className="my-4 w-full">
                        <FormTextField
                          name={"payment_duration"}
                          label={"Payment Duration"}
                          placeholder={`Enter payment duration`}
                        />
                      </div>

                      <div className="my-4 w-full">
                        <FormTextField
                          name={"transport_vehical_number"}
                          label={"Transport Vehicle Number"}
                          placeholder={`Enter transport vehicle number`}
                        />
                      </div>
                    </section>
                  </section>
                  <section>
                    <OrderProductItem
                      products={products}
                      productList={productList}
                      setOrderValues={setOrderValues}
                      setOrderProducts={setOrderProducts}
                      delivery_state={selctedCustomerDeliveryData?.state?.name}
                      cartValues={[...data.products]}
                    />
                  </section>
                </section>

                <section className="w-full flex justify-end gap-10 mt-5">
                  <div className="w-full max-w-[20rem] flex flex-col items-end">
                    <div className="flex gap-5 text-end">
                      <label className="text-end">Final Cash Value (A)</label>{" "}
                      <div>{orderValues.total_cash_amount}</div>
                    </div>
                    <div className="flex gap-5 mt-4">
                      <label>Total Invoice Amount (A+B)</label>{" "}
                      <div>{orderValues.total_invoice_value}</div>
                    </div>
                  </div>
                  <div className="w-full max-w-[15rem]">
                    <div className="flex gap-5 text-end">
                      <label className="text-end">Item Total</label>{" "}
                      <div>{orderValues.sgst}</div>
                    </div>
                    <div className="flex gap-5 mt-4">
                      <label>SGST Amount</label> <div>{orderValues.sgst}</div>
                    </div>
                    <div className="flex gap-5 mt-4">
                      <label>CGST Amount</label> <div>{orderValues.cgst}</div>
                    </div>
                    <div className="flex gap-5 mt-4">
                      <label>I GST Amount</label> <div>{orderValues.igst}</div>
                    </div>
                    <div className="flex gap-5 mt-4">
                      <label>Final Value (B)</label>{" "}
                      <div>{orderValues.total_after_tax}</div>
                    </div>
                  </div>
                </section>
              </Form>
            );
          }}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditOrders;
